import { Stack, Text } from '@chakra-ui/react'

import { t } from '@/lib/helpers'
import { Transaction } from '../../types'
import { formatMoney } from '../CheckoutSummary'

type Props = {
  transaction: Pick<Transaction, 'amount' | 'gross_amount' | 'wht_percent'>
}

export const BankTransferAmount = ({ transaction }: Props) => {
  const {
    amount,
    gross_amount: grossAmount,
    wht_percent: whtPercent,
  } = transaction

  // Rows without a gross_amount (card payments, rows from before WHT) owe the full amount
  const amountToTransfer = Number(grossAmount ?? amount)
  const whtRate = Number(whtPercent)

  return (
    <Stack spacing={3}>
      <Text fontSize="sm" color="gray.500">
        Amount to transfer
      </Text>
      <Text fontSize="2xl" fontWeight="bold">
        {formatMoney(amountToTransfer)} THB
      </Text>
      {whtRate > 0 && (
        <Text fontSize="sm" color="gray.500">
          {t('views.features.packages.checkout.wht_title')} {whtRate}%
        </Text>
      )}
    </Stack>
  )
}
